import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import '../styles/AdminOverlay.css';
import '../styles/AdminPanels.css';
import AdminAnalyticsPanel from './AdminAnalyticsPanel';
import AdminContentPanel from './AdminContentPanel';
import AdminSettingsPanel from './AdminSettingsPanel';
import AdminUsersPanel from './AdminUsersPanel';

const AdminOverlay = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('dashboard');
  const [showPanel, setShowPanel] = useState(null);
  const { user, isAdmin, logout } = useAuth();
  const navigate = useNavigate();

  if (!isAdmin) return null;

  const adminTabs = [
    { id: 'dashboard', label: 'Dashboard', icon: 'fas fa-tachometer-alt', path: '/admin' },
    { id: 'content', label: 'Content', icon: 'fas fa-edit', action: 'content' },
    { id: 'users', label: 'Users', icon: 'fas fa-users', action: 'users' },
    { id: 'analytics', label: 'Analytics', icon: 'fas fa-chart-bar', action: 'analytics' },
    { id: 'settings', label: 'Settings', icon: 'fas fa-cog', action: 'settings' }
  ];

  const handleTabClick = (tab) => {
    setActiveTab(tab.id);
    if (tab.path) {
      navigate(tab.path);
    } else if (tab.action) {
      handleAdminAction(tab.action);
    }
  };

  const handleAdminAction = (action) => {
    setShowPanel(action);
  };

  const handleClosePanel = () => {
    setShowPanel(null);
  };

  const handleLogout = () => {
    logout();
    setIsOpen(false);
  };

  return (
    <>
      {/* Admin Toggle Button */}
      <button 
        className="admin-toggle-btn"
        onClick={() => setIsOpen(!isOpen)}
        title="Admin Panel"
      >
        <i className="fas fa-crown"></i>
      </button>

      {/* Admin Overlay */}
      {isOpen && (
        <div className="admin-overlay">
          <div className="admin-panel">
            <div className="admin-header">
              <div className="admin-user-info">
                <div className="admin-avatar">
                  <i className="fas fa-user-shield"></i>
                </div>
                <div className="admin-details">
                  <h3>Admin Panel</h3>
                  <p>{user?.email}</p>
                </div>
              </div>
              <button 
                className="admin-close-btn"
                onClick={() => setIsOpen(false)}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="admin-tabs">
              {adminTabs.map(tab => (
                <button
                  key={tab.id}
                  className={`admin-tab ${activeTab === tab.id ? 'active' : ''}`}
                  onClick={() => handleTabClick(tab)}
                >
                  <i className={tab.icon}></i>
                  <span>{tab.label}</span>
                </button>
              ))}
            </div>

            <div className="admin-actions">
              <Link to="/admin" className="admin-action-btn primary">
                <i className="fas fa-external-link-alt"></i>
                Full Admin Dashboard
              </Link>
              <button 
                className="admin-action-btn danger"
                onClick={handleLogout}
              >
                <i className="fas fa-sign-out-alt"></i>
                Logout
              </button>
            </div>

            <div className="admin-quick-stats">
              <div className="stat-item">
                <i className="fas fa-users"></i>
                <span>Signups</span>
                <strong>Loading...</strong>
              </div>
              <div className="stat-item">
                <i className="fas fa-eye"></i>
                <span>Page Views</span>
                <strong>Today</strong>
              </div>
              <div className="stat-item">
                <i className="fas fa-clock"></i>
                <span>Last Login</span>
                <strong>Now</strong>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Admin Panels */}
      {showPanel === 'content' && (
        <AdminContentPanel onClose={handleClosePanel} />
      )}
      {showPanel === 'users' && (
        <AdminUsersPanel onClose={handleClosePanel} />
      )}
      {showPanel === 'analytics' && (
        <AdminAnalyticsPanel onClose={handleClosePanel} />
      )}
      {showPanel === 'settings' && (
        <AdminSettingsPanel onClose={handleClosePanel} />
      )}
    </>
  );
};

export default AdminOverlay;
